import { RecordScreen } from "@/lib/Components/Screens/RecordScreen/RecordScreen";
import {
  DocumentTextIcon,
  ExclamationTriangleIcon,
} from "@heroicons/react/24/outline";
import { useTranslations } from "use-intl";
import { useProDriverRecord } from "@/app/ProDrivers/Drivers/Hooks/useProDriverRecord";

export function ProDriverRecordScreen() {
  const t = useTranslations("proDriver");
  const proDriver = useProDriverRecord();

  return (
    <RecordScreen
      tabParams={{ id: proDriver.id }}
      title={proDriver?.name ?? "--"}
      tabs={[
        {
          name: "Details",
          Icon: DocumentTextIcon,
          to: "/$tenant/$orgId/supplier/{-$supplierId}/pro-drivers/drivers/$id",
        },
        {
          name: t("incidents"),
          Icon: ExclamationTriangleIcon,
          to: "/$tenant/$orgId/supplier/{-$supplierId}/pro-drivers/drivers/$id/incidents",
          isAdminTab: true,
          notificationCount: proDriver.incidentCount ?? undefined,
        },
      ]}
    />
  );
}
